/* import libraries */
import { useState } from "react";
import { useLocation, Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

/* import components */
import Container from "react-bootstrap/Container";
import Menu from "../components/Menu";
import IssueCard from "../components/IssueCard";

/* import services */
import ticketsApi from "../api/ticketsApi";

const IssueHistory = () => {
  const { state } = useLocation();
  const [issues, setIssues] = useState(state.issues);
  const [currPage, setCurrPage] = useState(2);
  const [hasMore, setHasMore] = useState(true);

  const getAllTickets = async (page) => {
    try {
      const response = await ticketsApi.getTickets({perPage: 10, page: page});
      setCurrPage(currPage+1);
      if (response.status) {
        setIssues([...issues, ...response.data.data]);
        if (response.data.data.length < 10) {
          setHasMore(false);
        }
      } else {
        console.error(response.error.msg);
      }
    } catch (error) {
      console.error("Error while fetching tickets: " + error.message)
    }
  }
  
  return (
      <>  
        <Menu title="Support Requests" />
        <Container style={{ paddingTop: "20px" }}>
            <h3 className="grey font-bold" style={{ fontSize: "16px", paddingTop:"10px"}}>
                Raised Ticket
            </h3>
            <InfiniteScroll 
                dataLength={currPage * 10}
                next={() => getAllTickets(currPage)} 
                hasMore={hasMore} 
                loader={<h6>Loading...</h6>}
            >
              {issues.map(issue => 
                  issue.status !== "closed" ? 
                  <Link 
                    key={issue.id} 
                    to={`/issue/${issue.id}`} 
                    state={{ issue }} 
                    style={{ textDecoration: "none"}}>
                      <IssueCard key={issue.id} issue={issue} />
                  </Link> : <></>)
              }
            </InfiniteScroll>

            <h3 className="grey font-bold" style={{ fontSize: "16px", paddingTop:"5px"}}>
                Closed Ticket
            </h3>
            <InfiniteScroll 
                dataLength={currPage * 10}
                next={() => getAllTickets(currPage)} 
                hasMore={hasMore} 
                loader={<h6>Loading...</h6>}
            >
              {issues.map(issue => 
                  issue.status === "closed" ? 
                  <Link 
                    key={issue.id} 
                    to={`/issue/${issue.id}`} 
                    state={{ issue }} 
                    style={{ textDecoration: "none"}}>
                      <IssueCard key={issue.id} issue={issue} />
                  </Link> : <></>)
              }
            </InfiniteScroll>
          </Container>
      </>
    );
  }

  export default IssueHistory;